import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { MdInfoOutline } from 'react-icons/md'
import { openModal } from '../../redux/reducers/modalSlice'
import HelpPanel from './HelpPanel'
import styles from './Help.module.scss'

/**
 * Info (i) icon. Opens help in a window on top of the current screen.
 * context: screen key, for example "dialer". Without it the button opens all topics.
 */
const HelpTip = ({ context, label, className }) => {
  const dispatch = useDispatch()
  const open = () =>
    dispatch(
      openModal({
        show: true,
        content: <HelpPanel context={context} />,
        size: 'md',
        closeOnOutsideClick: true,
      }),
    )
  return (
    <button
      type='button'
      className={`${styles.tipButton} ${className || ''}`}
      onClick={open}
      aria-label={label || 'Help'}
      title={label || 'Help'}
    >
      <MdInfoOutline />
    </button>
  )
}

HelpTip.propTypes = {
  context: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
}

export default HelpTip
